export default {
  newDesign: true,
  slotFirst: true,
  ageRules: { min: 5, max: 17 },
  parameters: {
    segment: 7,
    landing_id: "PlQRGcc",
    fb_pixel: 1113125277872242,
  },
  title: "Darmowy kurs dla twórców gier Roblox | Kodland",
  downtimeUrl: "https://www.kodland.org/pl",
  startPage: {
    title: "Darmowy kurs dla twórców gier Roblox",
    subtitle:
      "Zapisz swoje dziecko na darmowy kurs, aby nauczyło się jak projektować i programować gry w Roblox!",
    image: {
      url: "/welcome/pl_roblox_pc.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/pl_roblox_mob.png",
      style: {
        width: "100%",
      },
    },
    button: "Zapisz się 🚀",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Dziękujemy za zaufanie naszej platformie edukacyjnej!",
    subtitle:
      "Niestety, tablety lub telefony nie nadają się do korzystania z naszych lekcji. Będziemy szczęśliwi, widząc Was na naszych zajęciach następnym razem!",
  },
  quizRotateBySteps: {
    1: {
      question:
        "Czy Twoje dziecko lubi grać w gry wideo, takie jak Roblox lub Minecraft?",
      answers: [
        "👉 Tak, uwielbia je!",
        "👉 Czasami",
        "👉 Ale nie często",
      ],
    },
    2: {
      question:
        "Czy Twoje dziecko wykazuje zainteresowanie tworzeniem postaci, historii lub światów?",
      answers: [
        "Tak, ma bardzo rozwiniętą wyobraźnię",
        "Trochę, ale potrzebuje wskazówek",
        "Nie za bardzo, woli inne zajęcia",
      ],
    },
    3: {
      question:
        "Czy Twoje dziecko lubi rozwiązywać zagadki lub rozumieć, jak działają gry?",
      subtitle:
        "To pomoże nam odpowiednio dobrać wykwalifikowanego nauczyciela pod charakter Twojego dziecka.",
      answers: [
        "Tak, lubi wyzwania i łamigłówki",
        "Czasami, jeśli jest to część gry",
        "Nie, woli prostsze gry",
      ],
    },
    4: {
      question: "Jak Twoje dziecko spędza większość wolnego czasu?",
      answers: [
        "Grając w gry wideo",
        "Oglądając YouTube lub telewizję",
        "Wykonując kreatywne czynności, takie jak malowanie lub budowanie",
        "Angażuje się w zajęcia na świeżym powietrzu lub uprawia sport",
      ],
    },
    5: {
      title: "Ile lat ma Twoje dziecko?",
      type: "age",
      button: "",
    },
    6: {
      question: "Czy masz komputer/laptop?",
      answers: [
        "✔️ Tak",
        {
          answer: "❌ Nie",
          stopAnswer: true,
        },
      ],
    },
    7: {
      title:
        "Kiedy chcesz, abyście Ty i Twoje dziecko odbyli razem pierwszą darmową lekcję?",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    8: {
      title: "Uzupełnij dane kontaktowe, aby uzyskać dostęp do darmowego kursu",
      type: "one-page-contacts",
      subtitle: "",
      button: "Prawie skończone 🔥",
    },
    9: {
      title: "Przejrzyj te informacje, aby zakończyć rejestrację ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Pamiętaj, że do lekcji będziesz potrzebować działającego komputera stacjonarnego lub laptopa i musisz towarzyszyć swojemu dziecku przez cały czas trwania zajęć. Pamiętaj, że zajęcia są indywidualne i spersonalizowane.",
      button: "Co jeszcze?",
    },
    10: {
      title:
        "Przed zajęciami próbnymi sprawdź swoją skrzynkę e-mail i WhatsApp 📞",
      typeInfo: "whatsapp",
      subtitle:
        "Na 24 godziny przed zajęciami wyślemy przypomnienie, a na 2 godziny przed zajęciami poprosimy o potwierdzenie obecności. Bardzo ważne jest, abyśmy pozostali w kontakcie, aby zajęcia nie zostały odwołane.",
      button: "Co jeszcze?",
    },
    11: {
      title: "Lekcja odbędzie się na naszej platformie 💻",
      typeInfo: "classroom",
      subtitle:
        "Otrzymasz link i unikalny kod przez WhatsApp oraz e-mail. Wystarczy kliknąć w link, a przeniesie Cię on prosto do lekcji. Bez dodatkowych aplikacji, bez pobierania.",
      button: "Rozumiem ✅",
    },
  },
};
